import React, { useState } from "react";
import { useParams } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
} from "@mui/material";
import SubscribeButton from "./SubscribeButton";

const SubscribeModal = ({ open, setOpen }) => {
  const { artistKey } = useParams();

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
        },
      }}
    >
      <DialogTitle sx={{ textAlign: "center" }}>
        Subscribe to @{artistKey}
      </DialogTitle>

      <DialogContent>
        <SubscribeButton artistKey={artistKey} />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setOpen(false);
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubscribeModal;
